<template>
  <div class="buy__card--div">
    <a-card class="buy__card" :bordered="false">
      <template slot="title">
        <span class="title__span">购买产品</span>
      </template>
      <div class="vip_choose">
        <div
          class="vip_level"
          :class="chooseVipLevelId == item.id ? 'vip_box_shadow' : ''"
          v-for="(item, index) in vipLevelList"
          :key="index"
          :style="{
            backgroundImage:
              chooseVipLevelId == item.id
                ? 'url(' + item.chooseBackgroundImg + ')'
                : 'url(' + item.backgroundImg + ')',
          }"
          @click="chooseVipLevel(item.id)"
        >
          <div class="vip_name">{{ item.name }}</div>
          <div
            :class="
              item.id == chooseVipLevelId ? 'vip_price' : 'vip_price_noChoose'
            "
          >
            {{ item.price }}<span>元起</span>
          </div>
          <div class="divide_line" />
          <div class="vip_description">{{ item.description }}</div>
        </div>
      </div>
      <div class="vip_choose" style="margin-top: 54px">
        <div
          class="vip_month"
          :class="chooseVipMonthId == item.id ? 'vip_box_shadow' : ''"
          v-for="(item, index) in monthlist"
          :key="index"
          :style="{
            backgroundImage:
              chooseVipMonthId == item.id
                ? 'url(' + item.chooseBackgroundImg + ')'
                : 'url(' + item.backgroundImg + ')',
          }"
          @click="chooseVipMonth(item.id)"
        >
          <div class="vip_name">有效期</div>
          <div
            :class="
              item.id == chooseVipMonthId ? 'vip_price' : 'vip_price_noChoose'
            "
          >
            {{ item.price }}<span>元</span>
          </div>
          <div v-if="item.oldPrice != undefined" class="sale-detail">
            <span>{{ item.oldPrice }} </span> | {{ item.description }}
          </div>
          <div class="divide_line" />
          <div class="vip_description">{{ item.month }}</div>
        </div>
      </div>
      <div class="con__div">
        
        <p class="con__price--p">
          <a-input
            :placeholder="inputPlaceholder"
            :value="inputNum"
            @change="changeInputNum"
          />
          <span class="price-name">应付金额:</span>
          <span>{{ amountPayable }}元</span>
          <span class="price-title">{{ chooseVipLevelId == 1 ? '项目个数：' : '人员数量：' }}</span>
        </p>
        <!-- <p class="con__price--info">支付即同意《毫末科技服务协议》</p> -->
        <div class="more__protocol">
          <a-collapse :bordered="false" expandIconPosition="right">
            <a-collapse-panel key="1" header="更多协议" :style="customStyle">
              <a-radio :checked="autoRenew" @click="chooseAutoRenew"
                >自动续费</a-radio
              >
            </a-collapse-panel>
          </a-collapse>
        </div>
      </div>
    </a-card>
    <div class="pay__card">
      <a-radio-group
        :value="payWay"
        class="pay_way"
        size="large"
        @change="changePayWay"
      >
        <a-radio value="wx">
          <img
            :src="wechart"
            style="width: 20.9px; height: 18.5px"
            class="pay_img"
          />微信支付
        </a-radio>
        <a-radio value="zfb">
          <img
            :src="zhifubao"
            style="width: 19.7px; height: 19.7px"
            class="pay_img"
          />
          支付宝
        </a-radio>
      </a-radio-group>
      <div>
        <a-button class="pay_button" type="primary" @click="payInterface"
          >立即支付</a-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import payApi from "@/request/api-manager/pay.js";
import orderApi from "@/request/api-manager/order.js";

import Vue from "vue";
import { TOKEN, USER_ID, USER_NAME } from "@/store/mutation-types";
import CONSTANTS from "@/utils/constant";

export default {
  name: "Buy",
  data() {
    return {
      chooseVipLevelId: 1,
      chooseVipMonthId: 1,
      zhifubao: require("@/assets/zhifubao.png"),
      wechart: require("@/assets/wechart.png"),
      vipLevelList: [
        {
          id: 1,
          name: "开发者",
          price: 79.9,
          description: "按照项目个数收费",
          chooseBackgroundImg: require("@/assets/component/buy/developerChoose.png"),
          backgroundImg: require("@/assets/component/buy/developerUnChoose.png"),
        },
        {
          id: 2,
          name: "团队",
          price: 129.9,
          description: "按照团队人数收费",
          chooseBackgroundImg: require("@/assets/component/buy/teamChoose.png"),
          backgroundImg: require("@/assets/component/buy/teamUnChoose.png"),
        },
        {
          id: 3,
          name: "企业",
          price: 349.9,
          description: "按照企业人数收费",
          chooseBackgroundImg: require("@/assets/component/buy/companyChoose.png"),
          backgroundImg: require("@/assets/component/buy/companyUnChoose.png"),
        },
      ],
      monthlist: [
        {
          id: 1,
          month: "1个月",
          price: 79.9,
          chooseBackgroundImg: require("@/assets/component/buy/validityChoose.png"),
          backgroundImg: require("@/assets/component/buy/validityUnChoose.png"),
        },
        {
          id: 3,
          month: "3个月",
          price: 239.7,
          // oldPrice: "79元",
          // description: "低至每天0.77元",
          // chooseBackgroundImg: require("@/assets/component/buy/validityActivity.png"),
          chooseBackgroundImg: require("@/assets/component/buy/validityChoose.png"),
          backgroundImg: require("@/assets/component/buy/validityUnChoose.png"),
        },
        {
          id: 6,
          month: "6个月",
          price: 479.4,
          // oldPrice: "99元",
          // description: "低至每天0.5元",
          // chooseBackgroundImg: require("@/assets/component/buy/validityActivity.png"),
          chooseBackgroundImg: require("@/assets/component/buy/validityChoose.png"),
          backgroundImg: require("@/assets/component/buy/validityUnChoose.png"),
        },
        {
          id: 12,
          month: "12个月",
          price: 958.8,
          chooseBackgroundImg: require("@/assets/component/buy/validityChoose.png"),
          backgroundImg: require("@/assets/component/buy/validityUnChoose.png"),
        },
        {
          id: 36,
          month: "36个月",
          price: 2876.4,
          chooseBackgroundImg: require("@/assets/component/buy/validityChoose.png"),
          backgroundImg: require("@/assets/component/buy/validityUnChoose.png"),
        },
      ],
      payWay: "wx",
      inputPlaceholder: "请输入购买项目数量",
      inputNum: 1,
      customStyle:
        "background: #fff;border-radius: 4px;margin-bottom: 24px;border: 0;overflow: hidden",
      autoRenew: true,
      productName: "开发者",
      productDescription: "1个月",
      productPrice: 79.9,
    };
  },

  watch: {
    chooseVipLevelId(value) {
      this.inputPlaceholder =
        value == 1 ? "请输入购买项目数量" : "请输入购买人员数量";
    },
  },
  computed: {
    amountPayable() {
      const vipMonth = this.monthlist.filter(
        (item) => item.id === this.chooseVipMonthId
      )[0];
      console.log(vipMonth, "1111");
      if (this.inputNum == undefined) {
        return 0;
      }
      return parseFloat(vipMonth.price * this.inputNum).toFixed(1);
    },
  },
  methods: {
    chooseVipLevel(id) {
      let self = this;
      self.chooseVipLevelId = id;
      //给输入框设置默认值
      this.inputNum = id == 1 ? 1 : 5;
      //修改productName
      this.productName = this.vipLevelList[this.chooseVipLevelId - 1].name;
      this.productPrice = this.vipLevelList[this.chooseVipLevelId - 1].price;
      self.monthlist = self.monthlist.map((item) => {
        item.price = parseFloat(
          self.vipLevelList[id - 1].price * item.id
        ).toFixed(1);
        return item;
      });
    },
    chooseVipMonth(id) {
      this.chooseVipMonthId = id;
      //修改productDescription
      this.productDescription = this.monthlist.filter(
        (item) => item.id === this.chooseVipMonthId
      )[0].month;
    },
    //切换支付方式
    changePayWay(e) {
      this.payWay = e.target.value;
      console.log("value", e.target.value);
    },
    //点击支付
    payInterface() {
      let params = {
        sysUserId: Vue.ls.get(USER_ID),
        status: 0,
        payMonth: this.chooseVipMonthId,
        productName: this.productName,
        discount: 0,
        productPrice: this.productPrice,
        productType: CONSTANTS.PRODUCT_TYPE[this.productName],
        payPrice: parseFloat(this.amountPayable),
      };

      console.log(params);
      this.sendGenerateOrder(params);
    },
    //改变数量
    changeInputNum(e) {
      this.inputNum = e.target.value;
    },
    /**
     * 发送微信支付请求
     */
    sendWechatPayment(params) {
      payApi.wxPay(params).then((res) => {
        if (res.code > 0) {
          console.error("请求错误");
          return;
        }

        console.log(res);
        this.$router.push({
          path: "/WeChat-pay/index",
          query: { url: res.data },
        });
      });
    },
    /**
     * 发送支付宝支付请求
     */
    sendAlipayPayment(params) {
      const newTab = window.open();
      payApi.aliPay(params).then((res) => {
        console.log(res);
        const div = document.createElement("div");
        div.innerHTML = res; // html code
        newTab.document.body.appendChild(div);
        newTab.document.forms.punchout_form.submit();
      });
    },
    chooseAutoRenew() {
      this.autoRenew = !this.autoRenew;
    },
    /**
     * 发送生成订单请求
     */
    sendGenerateOrder(params) {
      let self = this;

      orderApi.add(params).then((res) => {
        if (res.code !== 200) {
          return console.log(res.message);
        }
        console.log(res);

        let data = {
          order_id: res.result.id,
          total_amount: res.result.payPrice,
          product_name: res.result.productName,
          product_description: CONSTANTS.MONTH[res.result.payMonth],
        };

        if (self.payWay === "wx") {
          data.total_amount = parseFloat(data.total_amount * 100).toFixed();
          self.sendWechatPayment(data);
        }

        if (self.payWay === "zfb") {
          self.sendAlipayPayment(data);
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
@import "./index.less";
</style>